import React, { Component, ReactNode } from "react";

interface ErrorBoundaryProps {
	children: ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
	error?: Error | undefined;
	info?: React.ErrorInfo | undefined;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	componentDidCatch(error: Error, info: React.ErrorInfo): void {
		this.setState({ hasError: true, error, info });
	}

	render(): React.ReactNode {
		if (this.state.hasError) {
			return (
				<div style={{ color: "red", whiteSpace: "pre", fontSize: "12px", position:"absolute", top:0, left:0,right:0,bottom:0, overflow: "auto" }}>
					<br />
					{this.state.error?.stack}
					<hr />
					{this.state.info?.componentStack}
				</div>
			);
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
